/** @jsx jsx */
import { jsx, Container, Heading, Grid, Box, Image, Text } from 'theme-ui'
import { FC } from 'react'
import { space } from '~/gatsby-plugin-theme-ui'
import { ButtonRugs } from '~/components/button-rug-collections'
import { Link } from 'gatsby'
import contemporaryRugCategories from '../../../static/media/contemporary-rug-categories.jpg'
import MobileCollectionCarousel from './mobile-collections-carousel'
import HeadingV2 from '~/componentsV2/heading'
import { FeaturedCollectionInterface } from './types'
import { FeaturedCollectionType } from '~/@types/models'
import { useDynamicCollectionMenus } from '~/containers/product-detail-v2/bespoke-detail/menus'

interface Props {
  title: string
  handle?: string
  headerDescription?: string
  featuredCollectionsList?: FeaturedCollectionType[]
}

const getDataTheme = () => {
  if (typeof window === 'undefined') {
    return null
  }

  const layoutContainer = document.getElementById('layout-container')
  return layoutContainer?.dataset.theme
}

const CollectionLinks: FC<Props> = ({
  title,
  featuredCollectionsList = [],
  handle,
  headerDescription,
}) => {
  const toReplace = '| BEN SOLEIMANI'
  const _title = title ? title?.toLowerCase().replace(toReplace, '-') : ''
  const slicedFeaturedCollectionsList =
    featuredCollectionsList?.length > 6
      ? featuredCollectionsList.slice(0, 6)
      : featuredCollectionsList

  return (
    <Container
      sx={{
        marginTop: '40px',
      }}
      className="collection-links"
    >
      <Box
        sx={{
          pt: [space.md3],
        }}
        className="mobile-collection-links"
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: space.sm, mb: space.l }}>
          {/* {isBespoke && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: space.sm }}>
              <Link to="/bespoke">HOME</Link>
              <span>/</span>
            </Box>
          )} */}
          <HeadingV2
            sx={{
              fontSize: '32px !important',
              textAlign: 'initial',
              mb: headerDescription ? [space.sm, space.md1] : 0,
              fontWeight: 400,
              color: 'text',
              textTransform: 'uppercase',
            }}
          >
            {handle === 'rugs' ? 'ALL RUGS' : title}
          </HeadingV2>
          {headerDescription && (
            <Box
              sx={{
                display: ['none', 'none', 'block'],
                pt: space.sm,
                width: ['100%', null, '70%', '50%'],
              }}
            >
              <Text sx={{ fontSize: '16px !important' }}>{headerDescription}</Text>
            </Box>
          )}
        </Box>
        <MobileCollectionCarousel featuredCollectionsList={featuredCollectionsList} />
      </Box>
    </Container>
  ) as JSX.Element
}

export default CollectionLinks
